import { render, staticRenderFns } from "./branchcompany.vue?vue&type=template&id=5453edaf"
import script from "./branchcompany.vue?vue&type=script&lang=js"
export * from "./branchcompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports